import LastOperations from 'app/components/LastOperations';
import { Box } from '@mui/material';
import PageHeader from 'app/components/PageHeader';
import {useTranslation} from "react-i18next";

const LastOperationsPage = () => {

    const {t} = useTranslation();

  return (
    <Box>
      <PageHeader pageName={t('homePage.history')} />
      <LastOperations bg={true} homePage={false} />
    </Box>
  );
};

export default LastOperationsPage;
